import {Component, OnInit} from "@angular/core";
import {MatButtonModule} from "@angular/material/button";

@Component({
  selector: "app-landing-page",
  templateUrl: "./landing-page.component.html",
  styleUrls: ["./landing-page.component.css"]
})
export class LandingPageComponent implements OnInit {
  constructor() {
  }

  ngOnInit(): void {
  }
}
